import { useContext } from 'react';

import { CookieSettingsContext } from '../Contexts/CookieSettingsContext';

const useCookieSettings = () => {
  return useContext(CookieSettingsContext);
};

export default useCookieSettings;
